import { PROJECT_TYPE } from 'src/shared/constants/constants'
import { Alert, Box, Stack } from '@mui/material'
import { PageLayout } from 'src/shared/layout/PageLayout'
import { ScreenLayout } from 'src/shared/layout/ScreenLayout'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { FeaturesSortList } from 'src/screens/shared/configuration/feature/FeaturesSortList'

type Props = {
  projectType: PROJECT_TYPE
}

export const FeaturesConfigurationProject = ({ projectType }: Props) => {
  const { getMessage } = useMessageSource()

  return (
    <ScreenLayout
      title={`${getMessage('label.navigation.configuration.features')} ${getMessage('label.configuration')}`}
    >
      <PageLayout>
        <Stack spacing={2}>
          <Box>
            <Alert severity="warning">{getMessage('label.warning.config.edit')}</Alert>
          </Box>

          <Stack spacing={5}>
            <FeaturesSortList projectType={projectType} />
          </Stack>
        </Stack>
      </PageLayout>
    </ScreenLayout>
  )
}
